import { render, staticRenderFns } from "./FlagPickerField.vue?vue&type=template&id=620ccb3e&scoped=true"
import script from "./FlagPickerField.vue?vue&type=script&setup=true&lang=js"
export * from "./FlagPickerField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FlagPickerField.vue?vue&type=style&index=0&id=620ccb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ccb3e",
  null
  
)

export default component.exports